// @flow

export function getBuildNumber(): number | string {
  // $FlowFixMe
  return process.env.REACT_APP_BUILD_TIME;
}